import { Component, OnInit } from '@angular/core';
import { Column } from '../shared/components/metro-table/metro-table.component';
import { RestService } from '@abp/ng.core';

@Component({
  selector: 'app-colppy-healthcheck',
  templateUrl: './colppy-healthcheck.component.html',
  standalone: false,
})
export class ColppyHealthCheckComponent implements OnInit {
      healthCheckData: any = {
        winesWithoutIdItem: [],
        winesWithDuplicateIdItem: [],
        pickUpsWithoutColppyWarehouse: [],
        logsSummary: {
          totalLogs: 0,
          errorLogs: 0,
          warningLogs: 0,
          informationLogs: 0,
          unresolvedErrors: 0,
          winesWithErrors: 0,
          pickUpsWithErrors: 0,
          recentErrors: []
        },
        wineAvailabilityCache: {
          isEmpty: true,
          totalWarehouses: 0,
          totalItems: 0,
          warehouses: []
        }
      };
  isLoading = false;
  
  // Control de acordeón para cache
  expandedWarehouses: Set<string> = new Set();
  
  // Logs paginados
  logsData: any = { items: [], totalCount: 0 };
  isLoadingLogs = false;
  showLogsSection = false;
  currentLogsPage = 1;
  logsPageSize = 20;
  
  // Filtros de logs
  logsFilters: any = {
    entityType: '',
    operation: '',
    logType: null,
    severity: null,
    isResolved: null,
    keyword: ''
  };

  // Columnas para la tabla de vinos sin idItem
  wineColumns: Column[] = [
    { name: 'name', label: '::Name', width: '30%' },
    { name: 'externalCode', label: '::ExternalCode', width: '25%', textColor: 'text-metro-blue-secondary' },
    { name: 'isActive', label: '::IsActive', width: '20%', textColor: 'text-metro-blue-secondary' },
    { name: 'id', label: '::Number', width: '15%', textColor: 'text-metro-blue-secondary' },
  ];

  // Columnas para la tabla de vinos con IdItemColppy duplicado
  duplicateIdItemColumns: Column[] = [
    { name: 'name', label: '::Name', width: '20%' },
    { name: 'description', label: '::Description', width: '25%', textColor: 'text-metro-blue-secondary' },
    { name: 'externalCode', label: '::ExternalCode', width: '15%', textColor: 'text-metro-blue-secondary' },
    { name: 'idItemColppy', label: '::IdItem', width: '15%', textColor: 'text-metro-blue-secondary' },
    { name: 'isActive', label: '::IsActive', width: '10%', textColor: 'text-metro-blue-secondary' },
    { name: 'id', label: '::Number', width: '10%', textColor: 'text-metro-blue-secondary' },
  ];

  // Columnas para la tabla de PickUps sin ColppyWarehouseName
  pickUpColumns: Column[] = [
    { name: 'name', label: '::Name', width: '25%' },
    { name: 'address', label: '::Address', width: '30%', textColor: 'text-metro-blue-secondary' },
    { name: 'email', label: '::Email', width: '25%', textColor: 'text-metro-blue-secondary' },
    { name: 'isActive', label: '::IsActive', width: '20%', textColor: 'text-metro-blue-secondary' },
  ];

  // Columnas para la tabla de errores recientes
  // winepassport#379 — los anchos sumaban 120% y la tabla "hacía zoom"/desbordaba. Rebalanceado a 100%.
  errorColumns: Column[] = [
    { name: 'creationTime', label: '::Date', width: '12%', textColor: 'text-metro-blue-secondary' },
    { name: 'entityType', label: '::EntityType', width: '9%' },
    { name: 'entityName', label: '::EntityName', width: '14%' },
    { name: 'externalCode', label: '::ExternalCode', width: '9%', textColor: 'text-metro-blue-secondary' },
    { name: 'operation', label: '::Operation', width: '16%', textColor: 'text-metro-blue-secondary' },
    { name: 'message', label: '::Message', width: '22%', textColor: 'text-metro-blue-secondary' },
    { name: 'attemptCount', label: '::Attempts', width: '9%', textColor: 'text-metro-blue-secondary' },
    { name: 'isResolved', label: '::Resolved', width: '9%', textColor: 'text-metro-blue-secondary' },
  ];

  // Columnas para la tabla de items en el cache
  cacheItemColumns: Column[] = [
    { name: 'idItem', label: '::IdItem', width: '15%' },
    { name: 'wineName', label: '::WineName', width: '35%' },
    { name: 'externalCode', label: '::ExternalCode', width: '20%', textColor: 'text-metro-blue-secondary' },
    { name: 'disponibilidad', label: '::Availability', width: '30%', textColor: 'text-metro-blue-secondary' },
  ];

  // Columnas para la tabla completa de logs
  logsColumns: Column[] = [
    { name: 'creationTime', label: 'Fecha', width: '12%' },
    { name: 'logType', label: 'Tipo', width: '8%' },
    { name: 'severity', label: 'Severidad', width: '8%' },
    { name: 'entityType', label: 'Entidad', width: '8%' },
    { name: 'entityName', label: 'Nombre', width: '15%' },
    { name: 'operation', label: 'Operación', width: '12%' },
    { name: 'message', label: 'Mensaje', width: '20%' },
    { name: 'attemptCount', label: 'Intentos', width: '7%' },
    { name: 'isResolved', label: 'Resuelto', width: '7%' },
  ];

  constructor(
    private restService: RestService
  ) {}

  ngOnInit(): void {
    console.log('ColppyHealthCheckComponent initialized');
    this.loadHealthCheck();
  }

  loadHealthCheck() {
    this.isLoading = true;
    
    this.restService.request<any, any>({
      method: 'GET',
      url: '/api/app/colppy-health-check/health-check'
    }, { apiName: 'Default' }).subscribe({
      next: (data) => {
        console.log('Raw health check data:', data);
        this.healthCheckData = this.formatHealthCheckData(data);
        console.log('Formatted health check data:', this.healthCheckData);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading Colppy health check:', err);
        this.isLoading = false;
        // En caso de error, mantener los datos por defecto
      }
    });
  }

  private formatHealthCheckData(data: any): any {
    // Formatear fechas y booleanos para la tabla
    const formattedData = { ...data };
    
    // Formatear fechas en vinos sin idItem
    if (formattedData.winesWithoutIdItem) {
      formattedData.winesWithoutIdItem = formattedData.winesWithoutIdItem.map((wine: any) => ({
        ...wine,
        creationTime: wine.creationTime ? new Date(wine.creationTime).toLocaleDateString() : '',
        isActive: wine.isActive ? 'Sí' : 'No'
      }));
    }

    // Formatear booleanos en vinos con IdItemColppy duplicado
    if (formattedData.winesWithDuplicateIdItem) {
      formattedData.winesWithDuplicateIdItem = formattedData.winesWithDuplicateIdItem.map((wine: any) => ({
        ...wine,
        description: wine.description || wine.Description || '',
        isActive: wine.isActive ? 'Sí' : 'No'
      }));
    }
    
    // Formatear fechas y booleanos en errores recientes
    if (formattedData.logsSummary?.recentErrors) {
      formattedData.logsSummary.recentErrors = formattedData.logsSummary.recentErrors.map((error: any) => ({
        ...error,
        creationTime: error.creationTime ? this.formatDateToArgentinaTimeZone(error.creationTime) : '',
        isResolved: error.isResolved ? 'Sí' : 'No'
      }));
    }
    
    // Asegurar que wineAvailabilityCache esté correctamente mapeado
    if (formattedData.wineAvailabilityCache) {
      // Los datos ya vienen del backend, solo asegurarnos de que estén presentes
      console.log('Cache data received:', formattedData.wineAvailabilityCache);
      
      // Normalizar isEmpty (puede venir como isEmpty o IsEmpty)
      formattedData.wineAvailabilityCache.isEmpty = formattedData.wineAvailabilityCache.isEmpty !== undefined 
        ? formattedData.wineAvailabilityCache.isEmpty 
        : (formattedData.wineAvailabilityCache as any).IsEmpty !== undefined 
          ? (formattedData.wineAvailabilityCache as any).IsEmpty 
          : false;
      
      // Normalizar otras propiedades
      formattedData.wineAvailabilityCache.totalWarehouses = formattedData.wineAvailabilityCache.totalWarehouses 
        || (formattedData.wineAvailabilityCache as any).TotalWarehouses 
        || 0;
      formattedData.wineAvailabilityCache.totalItems = formattedData.wineAvailabilityCache.totalItems 
        || (formattedData.wineAvailabilityCache as any).TotalItems 
        || 0;
      
      // Verificar y normalizar los nombres de propiedades a camelCase si es necesario
      if (formattedData.wineAvailabilityCache.warehouses || (formattedData.wineAvailabilityCache as any).Warehouses) {
        const warehouses = formattedData.wineAvailabilityCache.warehouses || (formattedData.wineAvailabilityCache as any).Warehouses || [];
        formattedData.wineAvailabilityCache.warehouses = warehouses.map((warehouse: any) => ({
          warehouseName: warehouse.warehouseName || warehouse.WarehouseName,
          itemCount: warehouse.itemCount || warehouse.ItemCount,
          items: (warehouse.items || warehouse.Items || []).map((item: any) => ({
            idItem: item.idItem || item.IdItem || '',
            disponibilidad: item.disponibilidad || item.Disponibilidad || '',
            wineName: item.wineName || item.WineName || 'N/A',
            externalCode: item.externalCode || item.ExternalCode || 'N/A'
          }))
        }));
      }
      
      // Si hay warehouses pero isEmpty es true, corregirlo
      if (formattedData.wineAvailabilityCache.warehouses && formattedData.wineAvailabilityCache.warehouses.length > 0) {
        formattedData.wineAvailabilityCache.isEmpty = false;
      }
    }
    
    return formattedData;
  }

  toggleWarehouse(warehouseName: string): void {
    if (this.expandedWarehouses.has(warehouseName)) {
      this.expandedWarehouses.delete(warehouseName);
    } else {
      this.expandedWarehouses.add(warehouseName);
    }
  }

  isWarehouseExpanded(warehouseName: string): boolean {
    return this.expandedWarehouses.has(warehouseName);
  }

  refresh() {
    this.loadHealthCheck();
    if (this.showLogsSection) {
      this.loadLogs();
    }
  }

  toggleLogsSection() {
    this.showLogsSection = !this.showLogsSection;
    if (this.showLogsSection && this.logsData.items.length === 0) {
      this.loadLogs();
    }
  }

  loadLogs() {
    this.isLoadingLogs = true;
    const skipCount = (this.currentLogsPage - 1) * this.logsPageSize;
    
    const params: any = {
      skipCount: skipCount,
      maxResultCount: this.logsPageSize,
      sorting: 'CreationTime DESC'
    };

    if (this.logsFilters.entityType) params.entityType = this.logsFilters.entityType;
    if (this.logsFilters.operation) params.operation = this.logsFilters.operation;
    if (this.logsFilters.logType !== null && this.logsFilters.logType !== '') params.logType = this.logsFilters.logType;
    if (this.logsFilters.severity !== null && this.logsFilters.severity !== '') params.severity = this.logsFilters.severity;
    if (this.logsFilters.isResolved !== null && this.logsFilters.isResolved !== '') params.isResolved = this.logsFilters.isResolved === 'true';
    if (this.logsFilters.fromDate) params.fromDate = this.logsFilters.fromDate;
    if (this.logsFilters.toDate) params.toDate = this.logsFilters.toDate;
    if (this.logsFilters.keyword) params.keyword = this.logsFilters.keyword;

    this.restService.request<any, any>({
      method: 'GET',
      url: '/api/app/colppy-health-check/logs',
      params: params
    }, { apiName: 'Default' }).subscribe({
      next: (data) => {
        this.logsData = {
          items: data.items.map((log: any) => ({
            ...log,
            creationTime: log.creationTime ? this.formatDateToArgentinaTimeZone(log.creationTime) : '',
            logType: this.getLogTypeLabel(log.logType),
            logTypeOriginal: log.logType, // Mantener el valor original para la función de color
            severity: this.getSeverityLabel(log.severity),
            isResolved: log.isResolved ? 'Sí' : 'No'
          })),
          totalCount: data.totalCount
        };
        this.isLoadingLogs = false;
      },
      error: (err) => {
        console.error('Error loading logs:', err);
        this.isLoadingLogs = false;
      }
    });
  }

  applyLogsFilters() {
    this.currentLogsPage = 1;
    this.loadLogs();
  }

  clearLogsFilters() {
    this.logsFilters = {
      entityType: '',
      operation: '',
      logType: null,
      severity: null,
      isResolved: null,
      keyword: ''
    };
    this.currentLogsPage = 1;
    this.loadLogs();
  }

  onLogsPageChange(page: number) {
    this.currentLogsPage = page;
    this.loadLogs();
  }

  get Math() {
    return Math;
  }

  private getLogTypeLabel(logType: number): string {
    switch (logType) {
      case 0: return 'Info';
      case 1: return 'Warning';
      case 2: return 'Error';
      default: return 'Unknown';
    }
  }

  private getSeverityLabel(severity: number): string {
    switch (severity) {
      case 0: return 'Baja';
      case 1: return 'Media';
      case 2: return 'Alta';
      case 3: return 'Crítica';
      default: return 'Unknown';
    }
  }

  // Función para determinar el color de la fila según el tipo de log
  getLogRowClass(row: any): string {
    // Verificar si es un error (logType === 2 o el texto "Error")
    if (row.logTypeOriginal === 2 || row.logType === 'Error') {
      return 'bg-red-50 hover:bg-red-100';
    }
    // Verificar si es una advertencia (logType === 1 o el texto "Warning")
    if (row.logTypeOriginal === 1 || row.logType === 'Warning') {
      return 'bg-yellow-50 hover:bg-yellow-100';
    }
    return '';
  }

  // Función para determinar el color de la fila en errores recientes
  getErrorRowClass(row: any): string {
    // En errores recientes, todas las filas son errores, así que siempre aplicamos el color
    return 'bg-red-50 hover:bg-red-100';
  }

  // Función para formatear fecha UTC a zona horaria de Argentina
  private formatDateToArgentinaTimeZone(dateString: string | Date): string {
    try {
      let date: Date;
      
      if (typeof dateString === 'string') {
        // El servidor envía fechas en formato ISO 8601, pero puede que no tenga 'Z' al final
        // Necesitamos asegurarnos de que se interprete como UTC
        let utcString = dateString.trim();
        
        // Si el string no tiene indicador de zona horaria (Z, +, -), asumir que es UTC
        // y agregar 'Z' para que JavaScript lo interprete como UTC
        if (!utcString.endsWith('Z') && 
            !utcString.match(/[+-]\d{2}:\d{2}$/) && 
            !utcString.match(/[+-]\d{4}$/)) {
          // Si termina con solo números o tiene formato ISO sin zona horaria, agregar 'Z'
          if (utcString.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/)) {
            utcString = utcString + 'Z';
          }
        }
        
        date = new Date(utcString);
      } else {
        date = dateString;
      }
      
      // Verificar que la fecha sea válida
      if (isNaN(date.getTime())) {
        console.warn('Fecha inválida:', dateString);
        return typeof dateString === 'string' ? dateString : dateString.toString();
      }
      
      // Usar Intl.DateTimeFormat para convertir UTC a zona horaria de Argentina
      // Esto automáticamente convierte la fecha UTC a la hora local de Argentina
      const formatter = new Intl.DateTimeFormat('es-AR', {
        timeZone: 'America/Argentina/Buenos_Aires',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });
      
      return formatter.format(date);
    } catch (error) {
      console.error('Error formateando fecha:', error, dateString);
      // Fallback a formato simple
      return typeof dateString === 'string' ? dateString : dateString.toString();
    }
  }
}

